import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from '../../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../../context/ApplicationContext';
import { PLATZHALTER_TEXT } from '../../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../../lib/types/types';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

const ResuemeeMassnahmeAbschlussStartUp: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title="Durchführung des Vorhabens" description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default ResuemeeMassnahmeAbschlussStartUp;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0252867758_ie_Ggf_Nicht_Erreicht_Werden,
				P.Abschlussbericht_Start_Up_Projekte.schema.attributes.Abschlussbericht_Start_U_0022841587_ngsboegen_Onlineumfragen_Etc,
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
export const getFormStrucResuemeeMassnahmeAbschlussStartUp = () => {
	return concat(formStruc());
};
